import { createStyles, makeStyles } from '@material-ui/core';
export var monolithMStart = 376;
export var monolithEmbeddedStarts = 541;
export var monolithEmbeddedStartsM = 810;
export var monolithLStarts = 990;
export var monolithXLStarts = 2560;
export var EmbeddedSignUpStyles = makeStyles(function (_a) {
    var _b, _c, _d, _e, _f;
    var spacing = _a.spacing, typography = _a.typography, breakpoints = _a.breakpoints;
    return createStyles({
        container: {},
        form: (_b = {},
            _b["@media (min-width:" + monolithMStart + "px)"] = {
                width: 330,
            },
            _b["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                width: '100%',
            },
            _b),
        formMui: (_c = {
                width: 330
            },
            _c[breakpoints.up('sm')] = {
                width: '100%',
            },
            _c),
        marketing: (_d = {
                display: 'none',
                fontFamily: ['"Kumlien Pro"', 'serif'].join(','),
                textAlign: 'center',
                marginBottom: spacing(0.5)
            },
            _d["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                display: 'block',
            },
            _d),
        marketingAlt: {
            fontFamily: ['"Kumlien Pro"', 'serif'].join(','),
            textAlign: 'center',
            marginBottom: spacing(0.5),
        },
        subTitle: (_e = {
                textAlign: 'center'
            },
            _e["@media (max-width:" + monolithEmbeddedStarts + "px)"] = {
                fontSize: typography.h3.fontSize,
                lineHeight: typography.h3.lineHeight,
                fontWeight: typography.h3.fontWeight,
            },
            _e),
        subTitleAlt: {
            textAlign: 'center',
        },
        formContainer: {
            marginTop: spacing(3),
        },
        iconContainer: (_f = {
                display: 'flex',
                justifyContent: 'center',
                marginTop: spacing(3.25)
            },
            _f[breakpoints.up('sm')] = {
                display: 'none',
            },
            _f),
    });
});
export var EmbeddedSignUpCardStyles = makeStyles(function (_a) {
    var _b, _c;
    var spacing = _a.spacing, breakpoints = _a.breakpoints, palette = _a.palette;
    return createStyles({
        root: (_b = {
                alignItems: 'center',
                backgroundColor: function (props) { var _a, _b; return (_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.backgroundColor) !== null && _b !== void 0 ? _b : palette.common.white; },
                borderRadius: 0,
                boxShadow: 'none',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                padding: spacing(4, 3),
                width: '100%',
                '& .MuiButton-startIcon': {
                    marginRight: spacing(6.75),
                },
                '& .form-separator > p': {
                    backgroundColor: function (props) { var _a, _b; return (_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.backgroundColor) !== null && _b !== void 0 ? _b : palette.common.white; },
                }
            },
            _b["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                borderRadius: spacing(2),
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                width: 346,
                '& .MuiButton-startIcon': {
                    marginRight: spacing(4.875),
                },
            },
            _b["@media (min-width:" + monolithLStarts + "px)"] = {
                width: 407,
                '& .MuiButton-startIcon': {
                    marginRight: spacing(8.75),
                },
            },
            _b),
        cardMui: (_c = {
                boxShadow: 'none',
                borderRadius: 0,
                width: '100%',
                '& .MuiButton-startIcon': {
                    marginRight: spacing(6.75),
                }
            },
            _c[breakpoints.up('sm')] = {
                width: 346,
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: spacing(2),
                '& .MuiButton-startIcon': {
                    marginRight: spacing(4.875),
                },
            },
            _c[breakpoints.up('lg')] = {
                width: 407,
                '& .MuiButton-startIcon': {
                    marginRight: spacing(8.75),
                },
            },
            _c),
    });
});
export var EmbeddedSignUpStylesIsLoggedOutHomeRedesign = makeStyles(function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var spacing = _a.spacing, typography = _a.typography, breakpoints = _a.breakpoints, palette = _a.palette;
    return createStyles({
        container: {
            justifyContent: 'center',
        },
        form: (_b = {
                minWidth: 375,
                width: 375
            },
            _b["@media (min-width:" + monolithEmbeddedStartsM + "px)"] = {
                minWidth: 304,
                width: 304,
            },
            _b["@media (min-width:" + monolithLStarts + "px)"] = {
                minWidth: 346,
                width: 346,
            },
            _b),
        formMui: (_c = {
                width: 330
            },
            _c[breakpoints.up('sm')] = {
                width: '100%',
            },
            _c),
        marketing: (_d = {
                color: palette.common.white,
                fontFamily: ['"Kumlien Pro"', 'serif'].join(','),
                textAlign: 'center',
                marginBottom: spacing(1),
                fontSize: 28,
                minWidth: 301,
                padding: spacing(0, 4.625)
            },
            _d["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                fontSize: 32,
                padding: spacing(0, 2.75),
                minWidth: 331,
            },
            _d["@media (min-width:" + monolithEmbeddedStartsM + "px)"] = {
                padding: spacing(0, 4.25),
                minWidth: 256,
            },
            _d["@media (min-width:" + monolithLStarts + "px)"] = {
                padding: spacing(0, 0),
                minWidth: 346,
            },
            _d),
        marketingAlt: {
            fontFamily: ['"Kumlien Pro"', 'serif'].join(','),
            textAlign: 'center',
            marginBottom: spacing(0.5),
        },
        subTitle: (_e = {
                color: palette.common.white,
                fontFamily: typography.fontFamily,
                textAlign: 'center',
                fontWeight: typography.fontWeightRegular,
                fontSize: typography.body2.fontSize,
                lineHeight: typography.body2.lineHeight,
                minWidth: 375
            },
            _e["@media (min-width:" + monolithEmbeddedStartsM + "px)"] = {
                minWidth: 304,
            },
            _e["@media (min-width:" + monolithLStarts + "px)"] = {
                minWidth: 346,
            },
            _e),
        subTitleAlt: {
            textAlign: 'center',
            fontSize: typography.h4.fontSize,
            lineHeight: typography.h4.lineHeight,
            fontWeight: 'normal',
        },
        formContainer: (_f = {
                marginTop: spacing(5),
                marginLeft: spacing(3),
                marginRight: spacing(3),
                minWidth: 327
            },
            _f["@media (min-width:" + monolithEmbeddedStartsM + "px)"] = {
                minWidth: 256,
            },
            _f["@media (min-width:" + monolithLStarts + "px)"] = {
                minWidth: 298,
            },
            _f),
        iconContainer: (_g = {
                display: 'flex',
                justifyContent: 'center',
                marginTop: spacing(3.25)
            },
            _g[breakpoints.up('sm')] = {
                display: 'none',
            },
            _g),
    });
});
export var EmbeddedSignUpCardStylesIsLoggedOutHomeRedesign = makeStyles(function (_a) {
    var _b, _c;
    var spacing = _a.spacing, breakpoints = _a.breakpoints, palette = _a.palette;
    return createStyles({
        root: (_b = {
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: palette.secondary.main,
                boxShadow: 'none',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                padding: spacing(4, 3),
                width: '100%',
                maxWidth: 375,
                '& .MuiButton-gr_loh_rd_startIcon': {
                    marginRight: spacing(6.75),
                },
                '& .form-separator > p': {
                    backgroundColor: palette.secondary.main,
                }
            },
            _b["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                '& .MuiButton-gr_loh_rd_startIcon': {
                    marginRight: spacing(4.875),
                },
            },
            _b["@media (min-width:" + monolithEmbeddedStartsM + "px)"] = {
                maxWidth: 304,
            },
            _b["@media (min-width:" + monolithLStarts + "px)"] = {
                maxWidth: 346,
                '& .MuiButton-gr_loh_rd_startIcon': {
                    marginRight: spacing(8.75),
                },
            },
            _b),
        cardMui: (_c = {
                boxShadow: 'none',
                borderRadius: 0,
                width: '100%',
                '& .MuiButton-startIcon': {
                    marginRight: spacing(6.75),
                }
            },
            _c[breakpoints.up('sm')] = {
                width: 346,
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: spacing(2),
                '& .MuiButton-startIcon': {
                    marginRight: spacing(4.875),
                },
            },
            _c[breakpoints.up('lg')] = {
                width: 407,
                '& .MuiButton-startIcon': {
                    marginRight: spacing(8.75),
                },
            },
            _c),
    });
});
//# sourceMappingURL=EmbeddedSignUpTypes.js.map